import { Backdrop, Box, Button, Checkbox, CircularProgress, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { complaintTracking } from '../../feature/api/Complaint'
import { removeResult } from '../../feature/ComplaintSlice/ComplaintSlice'
import { toast } from 'react-toastify'

const ComplaintTracking = () => {
  const [verCode,setVerCode] = useState()
  const [displayResult,setDisplayResult] = useState(false)
  const isLoadingTrack = useSelector(state => state.complaint.isLoadingTrack)
  const tracking = useSelector(state => state.complaint.tracking)
  const [Bot,setBot] = useState(false)
  const dispatch = useDispatch()
  const handleTracking = () => {
    if(Bot === true ) {
      if(verCode){
        dispatch(complaintTracking(verCode))

      }
     
    }else{
      toast.error('لطفا گزینه من ربات نیستم را فعال نمایید ')
    }
  }
  useEffect(() => {
    if(tracking?.length > 0){

      setDisplayResult(true)
    }else{
      setDisplayResult(false)
    }
  }, [tracking])
  
  return (
    <>
    {!displayResult? <Box display={"flex"} flexDirection={"column"} gap={2}>
          <Typography fontSize={"20px"} fontWeight={900} color="#dc7200">پیگیری شکایات و درخواست ها</Typography>
          <Typography variant='body2' color="#fff">لطفا کد رهگیری خود را وارد نمایید</Typography>
          <input  value={verCode} onChange={e => setVerCode(e.target.value)} type="tel" style={{color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',padding:'10px',borderRadius:'30px'}} />
          <Box border="1px solid #EF7C00" p="5px 10px" display={"flex"} justifyContent={"space-between"}>
              <Box display={"flex"} gap={1} alignItems={"center"}>
                  <Checkbox value={Bot} onChange={(e)=>setBot(!Bot)} sx={{ border:'1px solid #EF7C00',borderRadius:0,p:0}}  />
                  <Typography color="#fff">من ربات نیستم</Typography>
              </Box>
              <img src="/images/captch.png" alt="" />
          </Box>
          <Button onClick={handleTracking} sx={{bgcolor:'#dc7200',borderRadius:'20px'}} variant='contained'>پیگیری</Button>
      </Box> :
      <Box display={"flex"} flexDirection={"column"} gap={2} alignItems={"flex-end"}>
        <Box p="10px" border="1px solid #EF7C00" borderRadius={"18px"}>

          <Typography color={'#fff'} textAlign={"justify"}>{tracking}</Typography>
        </Box>
        <Button onClick={()=>{
          dispatch(removeResult())
          setDisplayResult(false)
          setBot(false)
          }} sx={{bgcolor:'#dc7200',borderRadius:'20px'}} variant='contained'>بازگشت</Button>

      </Box>
      }
          <Backdrop
            sx={{ color:'#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoadingTrack}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
    </>
  )
}

export default ComplaintTracking